interface Item {
  id: string;
  type: string;
}

interface ItemStatus extends Item{
  [action: string]: any;
}

export default function useItemVisited () {
  const itemStatusCacheTtl = useRuntimeConfig().public?.itemVisited?.ttl as number || 0;
  const { setCache, getData, getCacheWithCursor } = useCachedFetch('item-status', itemStatusCacheTtl);

  const action = async (item: Item, actionName: string) => {
    try {
      if (!item) {
        return;
      }
      if (import.meta.client) {
        const key = `${item?.type}-${item?.id}`;
        const { response: cacheData } = await getData(key);
        setCache(key, createOrAppendItemStatus(cacheData || item, actionName) || null);
      }
    } catch (error) {
      throw createError(`Error fetching data from cache ${error.message}`);
    }
  };

  const createOrAppendItemStatus = (item: ItemStatus, action: string): ItemStatus => {
    item[action] = item[action] ? [...item[action], Date.now()] : [Date.now()];
    return item;
  };

  const filterItemByAction = async (actionName: string) => {
    const { filter } = useRuntimeConfig()?.public.itemVisited;
    const result = [];

    await getCacheWithCursor(({ data }) => {
      if (data[actionName] && data[actionName].length >= filter[actionName]) {
        result.push(data.id);
      }
    });
    return result;
  };

  return { action, filterItemByAction };
}
